import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2cb79acd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "bg"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 1,
  class: "iconButton"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon-list"
}, null, -1));
const _hoisted_5 = {
  class: "searchWarp"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "types"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "imgWarp"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "name"
};
const _hoisted_13 = {
  key: 1,
  class: "noData loading"
};
const _hoisted_14 = {
  key: 2,
  class: "noData"
};
const _hoisted_15 = {
  key: 2,
  class: "model"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mobile = _resolveComponent("mobile");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`new3DList ${$data.isMobile ? 'h5' : ''} ${$data.pageType || 'white'}`),
    ref: "new3DList"
  }, [$data.pageType == 'luoshen' ? (_openBlock(), _createElementBlock("div", _hoisted_1)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "logo",
    style: _normalizeStyle($data.columns.length < 9 ? 'padding-left: 10px' : '')
  }, [$data.config.logo ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.config.logo
  }, null, 8, _hoisted_2)) : _createCommentVNode("", true)], 4), $data.pageType == 'luoshen' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", {
    class: "icon-apoints",
    onClick: _cache[0] || (_cache[0] = $event => $options.changeList())
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.keyword = $event),
    placeholder: "请输入搜索内容",
    onKeyup: _cache[2] || (_cache[2] = _withKeys($event => $options.getList('search'), ["enter", "native"]))
  }, null, 544), [[_vModelText, $data.keyword]]), _createElementVNode("div", {
    class: "btn",
    onClick: _cache[3] || (_cache[3] = $event => $options.getList('search'))
  }, "搜索")]), _createElementVNode("ul", {
    class: _normalizeClass(`columns ${$data.columns.length > 8 ? 'columnsMore' : ''}`)
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.columns, (item, index) => {
    return _withDirectives((_openBlock(), _createElementBlock("li", {
      class: _normalizeClass($data.columnIndex == index ? 'active' : ''),
      onClick: $event => $options.changeColumn(index)
    }, [_createElementVNode("div", null, _toDisplayString(item.columnName), 1)], 10, _hoisted_6)), [[_vShow, $data.columns.length > 2]]);
  }), 256))], 2), _createElementVNode("ul", _hoisted_7, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, n => {
    return _createElementVNode("li", {
      class: _normalizeClass($data.a_type == n ? 'active' : ''),
      onClick: $event => $options.getList('types', n)
    }, _toDisplayString($data.types[n - 1]), 11, _hoisted_8);
  }), 64))]), _createElementVNode("ul", {
    class: "list",
    onScroll: _cache[4] || (_cache[4] = (...args) => $options.scrollEvent && $options.scrollEvent(...args))
  }, [$data.list.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.list, item => {
    return _openBlock(), _createElementBlock("li", {
      onClick: $event => $options.toDetail(item)
    }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_11)]), _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1)], 8, _hoisted_9);
  }), 256)) : _createCommentVNode("", true), $data.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_13, "加载中")) : _createCommentVNode("", true), !$data.list.length && !$data.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_14, "暂无数据")) : _createCommentVNode("", true)], 32), $data.pageType == 'luoshen' ? (_openBlock(), _createElementBlock("div", _hoisted_15)) : _createCommentVNode("", true), _createVNode(_component_mobile)], 2);
}